import { render, staticRenderFns } from "./DasboardProfiling.vue?vue&type=template&id=38a5acb2&scoped=true"
import script from "./DasboardProfiling.vue?vue&type=script&lang=js"
export * from "./DasboardProfiling.vue?vue&type=script&lang=js"
import style0 from "./DasboardProfiling.vue?vue&type=style&index=0&id=38a5acb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5acb2",
  null
  
)

export default component.exports